module.exports = __webpack_public_path__ + "assets/img/1121587020865_.pic_hd.e9903f18.jpg";